import React from "react"
import './DocumentsBlockItem.scss'
import { Button } from "react-bootstrap";

function DocumentsBlockItem({num, title, href}) {

    return (
        <Button className='documents-block-item' as="a" variant="secondary" href={href} target="_blank" rel="noreferrer">
            <div className="btn-doc-container">
                <div className="btn-doc-up">
                    <div className="number">
                        {num}
                    </div>
                    <div className="download-icon"></div>
                </div>
                <div className="btn-doc-down">
                    <div className="title">
                        {title}
                    </div>
                </div>
            </div>
        </Button>
    );
}

export default DocumentsBlockItem;